import { QueryClient } from '@tanstack/react-query';
import { TRPCClientError } from '@trpc/client';

export const QUERY_CLIENT = new QueryClient({
  defaultOptions: {
    queries: {
      // Don't retry on 401 errors - let the error handler reload the page
      retry: (failureCount, error) => {
        // Don't retry 401 Unauthorized errors
        if (error instanceof TRPCClientError) {
          if (
            error.data?.httpStatus === 401 ||
            error.message.includes('Unauthorized') ||
            error.message.includes('No authentication token provided')
          ) {
            return false;
          }
        }
        // Retry other errors up to 3 times
        return failureCount < 3;
      },
      // Reduce stale time to encourage fresh data
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
    mutations: {
      // Don't retry mutations on 401 errors
      retry: (failureCount, error) => {
        if (error instanceof TRPCClientError) {
          if (
            error.data?.httpStatus === 401 ||
            error.message.includes('Unauthorized') ||
            error.message.includes('No authentication token provided')
          ) {
            return false;
          }
        }
        // Don't retry mutations by default
        return false;
      },
    },
  },
});
